import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import LazyImage from 'js/components/LazyImage/LazyImage'
import messages from './messages'
import barcode from './images/usp-barcode.svg'
import barcodeDimensions from './images/usp-barcode.svg?dimensions'
import diets from './images/usp-diets.svg'
import dietsDimensions from './images/usp-diets.svg?dimensions'
import mealplans from './images/usp-mealplans.svg'
import mealplansDimensions from './images/usp-mealplans.svg?dimensions'
import personalize from './images/usp-personalize.svg'
import personalizeDimensions from './images/usp-personalize.svg?dimensions'
import recipes from './images/usp-recipes.svg'
import recipesDimensions from './images/usp-recipes.svg?dimensions'
import trackers from './images/usp-trackers.svg'
import trackersDimensions from './images/usp-trackers.svg?dimensions'
import useBreakpoints from '../../hooks/useBreakpoints'

const defaultContent = [
  {
    image: diets,
    imageDimensions: dietsDimensions,
    heading: <FormattedMessage {...messages.whatislifesum_1_heading} />,
    text: <FormattedMessage {...messages.whatislifesum_1_text} />,
  },
  {
    image: mealplans,
    imageDimensions: mealplansDimensions,
    heading: <FormattedMessage {...messages.whatislifesum_2_heading} />,
    text: <FormattedMessage {...messages.whatislifesum_2_text} />,
  },
  {
    image: recipes,
    imageDimensions: recipesDimensions,
    heading: <FormattedMessage {...messages.whatislifesum_3_heading} />,
    text: <FormattedMessage {...messages.whatislifesum_3_text} />,
  },
  {
    image: barcode,
    imageDimensions: barcodeDimensions,
    heading: <FormattedMessage {...messages.whatislifesum_4_heading} />,
    text: <FormattedMessage {...messages.whatislifesum_4_text} />,
  },
  {
    image: trackers,
    imageDimensions: trackersDimensions,
    heading: <FormattedMessage {...messages.whatislifesum_5_heading} />,
    text: <FormattedMessage {...messages.whatislifesum_5_text} />,
  },
  {
    image: personalize,
    imageDimensions: personalizeDimensions,
    heading: <FormattedMessage {...messages.whatislifesum_6_heading} />,
    text: <FormattedMessage {...messages.whatislifesum_6_text} />,
  },
]

const USP = ({ image, imageDimensions, heading, text }) => {
  const { MD } = useBreakpoints()
  return (
    <div>
      {imageDimensions ? (
        <LazyImage
          src={image}
          height={
            MD
              ? imageDimensions.height
              : parseInt(imageDimensions.height * 0.67, 10)
          }
          width={
            MD
              ? imageDimensions.width
              : parseInt(imageDimensions.width * 0.67, 10)
          }
          alt=""
          className="mt-auto"
        />
      ) : (
        <img src={image} alt="" className="mt-auto" />
      )}
      <h3 className="type-med-fat mb-8 mt-24 md:mb-16 md:mt-40">{heading}</h3>
      <p className="type-default mb-16 leading-body">{text}</p>
    </div>
  )
}

USP.propTypes = {
  image: PropTypes.string.isRequired,
  imageDimensions: PropTypes.shape({
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }),
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
}

function WhatIsLifesum({ content = defaultContent }) {
  return (
    <div className="my-64 grid gap-12 text-center md:grid-cols-2 lg:grid-cols-3">
      {content.map((props, i) => {
        return <USP key={i} {...props} />
      })}
    </div>
  )
}

WhatIsLifesum.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.any.isRequired,
      imageDimensions: PropTypes.shape({
        height: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
      }).isRequired,
      heading: PropTypes.any.isRequired,
      text: PropTypes.any.isRequired,
    }).isRequired,
  ),
}

export default WhatIsLifesum
